import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import login from './moudel/login.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    login
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js